import React from 'react';
import Action, { IActionParentProps } from '../Action';
import useStreamingSession from '../../hooks/useSession';
import MarkdownContent from '../MarkdownContent';

function SherpaContent(message: string) {
  return (
    <div className='analysis'>
      <MarkdownContent content={message} />
    </div>
  );
}

export function Sherpa({ streamingSession, oggService }: IActionParentProps) {
  console.debug('loading sherpa');
  const [streamingContent] = useStreamingSession(streamingSession);

  return (
    <Action
      presentation={{
        name: 'The Sherpa',
        description: <p>I'll help you figure out where to go next</p>,
        imageName: 'TheSherpa.png',
        onStart: () => oggService.askSherpaStream(streamingSession),
      }}
      streamOutput={{
        loadingTitle: 'Ogg is looking at the work item...',
        loadingSubtitle: 'Figuring out the next steps',
        render: SherpaContent,
        streamingContent: streamingContent,
        streamingSession: streamingSession,
      }}
    ></Action>
  );
}
